/**
 * Pure helpers for round-robin preview (no storage).
 * @param {Array<{ assignee?: string, status?: string }>} conversations
 * @param {{ agents: Array<{ id: string, name: string, minConcurrentChats: number, maxConcurrentChats: number, isOnline?: boolean }>, agentOrderIds: string[], roundRobinCursor: number }} settings
 */

function countOpenForAgent(conversations, agentName) {
  return conversations.filter((c) => c.status === "open" && c.assignee === agentName).length;
}

/**
 * Next agent name in rotation who is Online and under max capacity (open chats only).
 * @returns {string | null}
 */
export function previewNextRoundRobinAssignee(conversations, settings) {
  if (!settings.roundRobinEnabled || !settings.agentOrderIds?.length) return null;
  const agentsById = new Map(settings.agents.map((a) => [a.id, a]));
  const n = settings.agentOrderIds.length;
  if (!n) return null;
  let idx = settings.roundRobinCursor % n;
  for (let step = 0; step < n; step += 1) {
    const id = settings.agentOrderIds[idx];
    const agent = agentsById.get(id);
    if (agent) {
      // When presence is known, skip Offline agents (matches backend eligibility).
      if (agent.isOnline === false) {
        idx = (idx + 1) % n;
        continue;
      }
      const open = countOpenForAgent(conversations, agent.name);
      if (open < agent.maxConcurrentChats) {
        return agent.name;
      }
    }
    idx = (idx + 1) % n;
  }
  return null;
}
